import { render, staticRenderFns } from "./fail3.vue?vue&type=template&id=2b8e7988&scoped=true"
import script from "./fail3.vue?vue&type=script&lang=js"
export * from "./fail3.vue?vue&type=script&lang=js"
import style0 from "./fail3.vue?vue&type=style&index=0&id=2b8e7988&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8e7988",
  null
  
)

export default component.exports